import React from 'react';
import { Box, FormControl, MenuItem, Select } from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import type { TicketCardAction, TicketCardActionOption } from '../../../types/lottery';

type TicketCardActionsProps = {
  actionOptions: TicketCardActionOption[];
  selectedAction: TicketCardAction;
  onActionChange: (action: TicketCardAction) => void;
  onSubmit: () => void;
  isDisabled: boolean;
  isSelectionDisabled: boolean;
  isLoading: boolean;
  selectLabelId: string;
};

const TicketCardActions: React.FC<TicketCardActionsProps> = React.memo(({
  actionOptions,
  selectedAction,
  onActionChange,
  onSubmit,
  isDisabled,
  isSelectionDisabled,
  isLoading,
  selectLabelId,
}) => {
  return (
    <Box className="actions">
      <FormControl fullWidth size="small">
        <Select
          labelId={selectLabelId}
          value={selectedAction}
          disabled={isSelectionDisabled}
          onChange={(event) => onActionChange(event.target.value as TicketCardAction)}
          className="select"
        >
          {actionOptions.map((option) => (
            <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={isDisabled || isLoading}
        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : undefined}
        className="submit-btn"
      >
        Submit
      </Button>
    </Box>
  );
});

TicketCardActions.displayName = 'TicketCardActions';

export default TicketCardActions;

